import { render } from "./EventRegistrationsDashboardPage.vue?vue&type=template&id=4b166a4c&scoped=true&ts=true"
import script from "./EventRegistrationsDashboardPage.vue?vue&type=script&lang=ts"
export * from "./EventRegistrationsDashboardPage.vue?vue&type=script&lang=ts"

import "./EventRegistrationsDashboardPage.vue?vue&type=style&index=0&id=4b166a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b166a4c"]])

export default __exports__